<template>
  <div class="pvtprediction-dashboard">
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
    <iframe
      v-else
      :src="iframeUrl"
      class="prediction-iframe"
      ref="predictionIframe"
      @load="handleIframeLoad"
    ></iframe>
  </div>
  <div v-if="isLoading" class="loader-container-eda">
    <div class="loader">
      <div class="spinner"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PVTPrediction",
  data() {
    return {
      error: null,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    iframeUrl() {
      const token = localStorage.getItem("authToken");
      const tenantId = this.$route.path.split('/')[1];
      if (!token || !tenantId) {
        this.error = "Authentication required";
        this.$router.push('/login');
        return null;
      }

      // Placeholder URL; update to your PVT prediction iframe endpoint as needed
      const baseUrl = process.env.VUE_APP_PVT_PREDICTION_URL;
      const darkMode = this.isDarkMode ? 'true' : 'false';
      const url = `${baseUrl}?token=${token}&tenantId=${tenantId}&darkMode=${darkMode}`;
      return url;
    }
  },
  mounted() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  methods: {
    handleIframeLoad() {
      const iframe = this.$refs.predictionIframe;
      if (iframe) {
        this.error = null;
        window.addEventListener('message', this.handleIframeMessage);
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      }
    },
    handleIframeMessage(event) {
      if (event.origin === (process.env.VUE_APP_PVT_PREDICTION_URL)) {
        const data = event.data;
        if (data && data.type === 'TOKEN_EXPIRED') {
          this.handleTokenExpiration();
        }
      }
    },
    handleTokenExpiration() {
      localStorage.removeItem("authToken");
      this.error = "Your session has expired. Please login again.";
      this.$router.push('/login');
    }
  },
  watch: {
    isDarkMode() {
      if (this.$refs.predictionIframe) {
        this.isLoading = true;
        this.$refs.predictionIframe.src = this.iframeUrl;
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleIframeMessage);
  }
};
</script>

<style scoped>
.pvtprediction-dashboard {
  width: 100%;
  height: calc(100vh - 64px);
  position: relative;
}

.prediction-iframe {
  width: 100%;
  min-height: 100%;
  border: none;
}

.loader-container-eda {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  z-index: 10;
}

.loader {
  text-align: center;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #145B80;
  border-top: 4px solid #f8f9fa;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: 0 auto 16px;
}

.dark-mode .spinner {
  border-color: #145B80;
  border-top: 4px solid #1F2937 !important;
}

.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
  color: #dc3545;
  background: #f8f9fa;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>


